<ng-container *ngIf="vm$ | async as vm">
    <form [formGroup]="campaignOpenForm">
        <kendo-dialog (close)="closeModal()" id="campaign-edit-modal"
                      [title]="'Campaign Edit'" [width]="600">

            <div class="kendo-dialog-body">

                <div class="form-group">
                    <label for="goalAmount" style="display: inline-block">
                        <span class="form-required" aria-hidden="true">*</span> Goal
                    </label>
                    <input class="form-control"
                           id="goalAmount"
                           name="goalAmount"
                           type="number"
                           formControlName="goalAmount" />
                    <div *ngIf="campaignOpenForm.get('goalAmount')!.errors && campaignOpenForm.get('goalAmount')!.touched">
                        <cl-error-validation-message *ngIf="campaignOpenForm.get('goalAmount')!.errors!.required"
                                                     id="goalAmount-required-error"
                                                     message="Goal is required.">
                        </cl-error-validation-message>
                        <cl-error-validation-message *ngIf="campaignOpenForm.get('goalAmount')!.errors!.max"
                                                     id="goalAmount-max-error"
                                                     message="You entered an amount that is too high. Please update your goal to be ''${{vm.capAmount | number:'1.0':'en-US'}}'' or less.">
                        </cl-error-validation-message>
                        <cl-error-validation-message *ngIf="campaignOpenForm.get('goalAmount')!.errors!.min"
                                                     id="goalAmount-min-error"
                                                     message="You enter an amount greater than 0.">
                        </cl-error-validation-message>
                    </div>
                </div>

                <div class="form-group">
                    <div class="form-required" style="padding-bottom: 5px;">*Required</div>
                    <p class="label-kendo" for="end-date" style="display: inline-block"><span class="form-required" aria-hidden="true">*</span> End Date</p>
                    <label for="datepicker-1" class="sr-only">End Date</label>
                    <kendo-datepicker class="form-control no-border" formControlName="endDate" id="end-date" required [min]="vm.endDateMin"></kendo-datepicker>
                    <div *ngIf="endDt?.errors && endDt?.touched">
                        <cl-error-validation-message *ngIf="endDt?.errors?.required" id="error-end-date-required" message="Please enter a value."></cl-error-validation-message>
                        <cl-error-validation-message *ngIf="endDt?.errors?.minError" id="error-end-date-minError" message="End Date must be in the future"></cl-error-validation-message>
                    </div>
                </div>
            </div>
            <kendo-dialog-actions layout="end">
                <button class="btn btn-primary" id="save-btn" type="submit" style="width: 75px;" (click)="openCampaign()" [disabled]="!campaignOpenForm.valid">Open</button>
                <button class="btn btn-default" (click)="closeModal()" id="cancel-btn" type="button" style="width: 75px;">Cancel</button>
            </kendo-dialog-actions>
        </kendo-dialog>
    </form>
</ng-container>